import { commonTokens } from "@smartsheet/design-tokens";
import { color } from "../tokenInjector/CommonTokenInjector";
import { sizes } from "./constants/spacing";
import { getCSSVariables } from "./utils/getCSSVariables";
export const ursaTheme = {
  key: "ursa-light",
  cssVariables: getCSSVariables("com", "ursa-light", commonTokens),
  skipLink: {
    container: {
      borderRadius: "8px",
      top: `${sizes.small}px`,
      padding: `0 ${sizes.small}px`,
      height: "48px",
      boxShadow: color("elevation--shadow-1"),
      gap: "small"
    },
    button: {
      padding: `0 ${sizes.xSmall}px`,
      fontSize: "14px",
      lineHeight: "18px",
      borderRadius: "6px",
      focusRingGap: 1
    }
  }
};
//# sourceMappingURL=ursaTheme.js.map